/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchAddStorePublicListingRequest,
    BatchDeleteStorePublicListingRequest,
    BatchSortStorePublicListingRequest,
    StorePublicListingMoveToTopRequest,
} from '../models';

export interface StorePublicListingApiControllerBatchAddStorePublicListingRequest {
    storeId: string;
    batchAddStorePublicListingRequest: BatchAddStorePublicListingRequest;
}

export interface StorePublicListingApiControllerBatchDeleteStorePublicListingRequest {
    storeId: string;
    batchDeleteStorePublicListingRequest: BatchDeleteStorePublicListingRequest;
}

export interface StorePublicListingApiControllerBatchSortStorePublicListingRequest {
    storeId: string;
    batchSortStorePublicListingRequest: BatchSortStorePublicListingRequest;
}

export interface StorePublicListingApiControllerStorePublicListingMoveToTopRequest {
    storeId: string;
    storePublicListingMoveToTopRequest: StorePublicListingMoveToTopRequest;
}

/**
 * 
 */
export class StorePublicListingApi extends runtime.BaseAPI {

    /**
     */
    async storePublicListingApiControllerBatchAddStorePublicListingRaw(requestParameters: StorePublicListingApiControllerBatchAddStorePublicListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePublicListingApiControllerBatchAddStorePublicListing.');
        }

        if (requestParameters.batchAddStorePublicListingRequest === null || requestParameters.batchAddStorePublicListingRequest === undefined) {
            throw new runtime.RequiredError('batchAddStorePublicListingRequest','Required parameter requestParameters.batchAddStorePublicListingRequest was null or undefined when calling storePublicListingApiControllerBatchAddStorePublicListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/public-listings:batch-add`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchAddStorePublicListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storePublicListingApiControllerBatchAddStorePublicListing(requestParameters: StorePublicListingApiControllerBatchAddStorePublicListingRequest): Promise<void> {
        await this.storePublicListingApiControllerBatchAddStorePublicListingRaw(requestParameters);
    }

    /**
     */
    async storePublicListingApiControllerBatchDeleteStorePublicListingRaw(requestParameters: StorePublicListingApiControllerBatchDeleteStorePublicListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePublicListingApiControllerBatchDeleteStorePublicListing.');
        }

        if (requestParameters.batchDeleteStorePublicListingRequest === null || requestParameters.batchDeleteStorePublicListingRequest === undefined) {
            throw new runtime.RequiredError('batchDeleteStorePublicListingRequest','Required parameter requestParameters.batchDeleteStorePublicListingRequest was null or undefined when calling storePublicListingApiControllerBatchDeleteStorePublicListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/public-listings:batch-delete`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchDeleteStorePublicListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storePublicListingApiControllerBatchDeleteStorePublicListing(requestParameters: StorePublicListingApiControllerBatchDeleteStorePublicListingRequest): Promise<void> {
        await this.storePublicListingApiControllerBatchDeleteStorePublicListingRaw(requestParameters);
    }

    /**
     */
    async storePublicListingApiControllerBatchSortStorePublicListingRaw(requestParameters: StorePublicListingApiControllerBatchSortStorePublicListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePublicListingApiControllerBatchSortStorePublicListing.');
        }

        if (requestParameters.batchSortStorePublicListingRequest === null || requestParameters.batchSortStorePublicListingRequest === undefined) {
            throw new runtime.RequiredError('batchSortStorePublicListingRequest','Required parameter requestParameters.batchSortStorePublicListingRequest was null or undefined when calling storePublicListingApiControllerBatchSortStorePublicListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/public-listings:batch-sort`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortStorePublicListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storePublicListingApiControllerBatchSortStorePublicListing(requestParameters: StorePublicListingApiControllerBatchSortStorePublicListingRequest): Promise<void> {
        await this.storePublicListingApiControllerBatchSortStorePublicListingRaw(requestParameters);
    }

    /**
     */
    async storePublicListingApiControllerStorePublicListingMoveToTopRaw(requestParameters: StorePublicListingApiControllerStorePublicListingMoveToTopRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storePublicListingApiControllerStorePublicListingMoveToTop.');
        }

        if (requestParameters.storePublicListingMoveToTopRequest === null || requestParameters.storePublicListingMoveToTopRequest === undefined) {
            throw new runtime.RequiredError('storePublicListingMoveToTopRequest','Required parameter requestParameters.storePublicListingMoveToTopRequest was null or undefined when calling storePublicListingApiControllerStorePublicListingMoveToTop.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/public-listings:batch-move-to-top`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.storePublicListingMoveToTopRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storePublicListingApiControllerStorePublicListingMoveToTop(requestParameters: StorePublicListingApiControllerStorePublicListingMoveToTopRequest): Promise<void> {
        await this.storePublicListingApiControllerStorePublicListingMoveToTopRaw(requestParameters);
    }

}
